import { BE_CONFIG } from './be';
import { CZ_CONFIG } from './cz';
import { FI_CONFIG } from './fi';
import { HU_CONFIG } from './hu';
import { IT_CONFIG } from './it';
import { MX_CONFIG } from './mx';
import { ES_TC_CONFIG } from './ts-tc';
import { UKDF_CONFIG } from './uk-dfp';
import { FormConfigInterface } from './interfaces/form-config.interface';
import GLOBAL_CONFIG from './global';

export const FORM_CONFIG: Record<string, FormConfigInterface> = {
  'uk-dfp': UKDF_CONFIG,
  'es-tc': ES_TC_CONFIG,
  hu: HU_CONFIG,
  fi: FI_CONFIG,
  cz: CZ_CONFIG,
  be: BE_CONFIG,
  it: IT_CONFIG,
  mx: MX_CONFIG,
  global: GLOBAL_CONFIG,
};
